var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.97664 0.72783C7.29875 -0.24261 8.70125 -0.24261 9.02336 0.727831L10.1742 4.19517C10.3183 4.62916 10.7314 4.923 11.1976 4.923H14.9219C15.9643 4.923 16.3977 6.22872 15.5544 6.82848L12.5413 8.97141C12.1642 9.23964 12.0064 9.71507 12.1505 10.1491L13.3013 13.6164C13.6234 14.5868 12.4888 15.3938 11.6455 14.7941L8.63247 12.6511C8.25534 12.3829 7.74466 12.3829 7.36753 12.6511L4.35449 14.7941C3.5112 15.3938 2.37655 14.5868 2.69866 13.6164L3.84954 10.1491C3.99359 9.71507 3.83579 9.23964 3.45866 8.97141L0.445614 6.82848C-0.397678 6.22872 0.0357171 4.923 1.07808 4.923H4.80241C5.26857 4.923 5.68171 4.62916 5.82576 4.19517L6.97664 0.72783Z",
    fill: "#00A3E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarBlue);
export default __webpack_public_path__ + "static/media/star-blue.da42c93df55640206078fbad06fe737b.svg";
export { ForwardRef as ReactComponent };